import { render } from "./RGPD.vue?vue&type=template&id=0e79c0c2&scoped=true"
import script from "./RGPD.vue?vue&type=script&lang=js"
export * from "./RGPD.vue?vue&type=script&lang=js"

import "./RGPD.vue?vue&type=style&index=0&id=0e79c0c2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e79c0c2"]])

export default __exports__